module.exports = __webpack_public_path__ + "static/img/ashta-blue.409c45b2.png";